'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderDetail = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderDetail = exports.OrderDetail = (0, _keymirror2.default)({
    PERSONAL_ORDER_DETAIL_LOAD: null,
    PERSONAL_ORDER_DETAIL_SUCCESS: null,
    PERSONAL_ORDER_DETAIL_FAIL: null,
    SET_PAYMENT_ID: null,
    LOAD_PAGE: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/personal/order_detail.js
// module id = 1877
// module chunks = 0